<nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light primary-color">
  <div class="container">

    <img alt="" src="https://s3.amazonaws.com/joyofjazz.content/tmusicman/logo/tmusicmanlogo.png" height="70px"
      [routerLink]="['/home']" />
    <button class="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
      (click)="onMenuClick()">
      <img src="assets/icons/menu.svg" class="img-fluid" width="30" />
    </button>

    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav  mx-auto">
        
        <!-- <li class="nav-item" routerLinkActive="active">
          <a  style="cursor: pointer;" class="dropdown-item nav-link" (click)="showStreamEvent()">
            <div class="update_indicator_container">
              <div class="update_indicator"></div>
            </div>
            Live
          </a>
        </li> -->

        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/concert']">Spectacular Concert</a>
        </li>

        <!-- <li class="nav-item dropdown" dropdown (onHover)="onAboutUsDropdownHover($event)" routerLinkActive="active">
          <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button">Spectacular Concert</a>
          <div class="dropdown-menu show dropdown-menu-right rounded-0" *ngIf="aboutUsDropdown">
            <a class="dropdown-item nav-link" (click)="showStreamEvent()">
              <div class="update_indicator_container">
                <div class="update_indicator"></div>
              </div>
              Live
            </a>
            <a class="dropdown-item nav-link" [routerLink]="['/concert']">Programs</a>
          </div>
        </li> -->

        <!-- <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" [routerLink]="['/concert']">Spectacular Concert</a>
        </li> -->
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/home']">Home</a>
        </li>
        <!-- <li class="nav-item dropdown" dropdown (onHover)="onAboutUsDropdownHover($event)" routerLinkActive="active">
          <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button">About Us</a>
          <div class="dropdown-menu show dropdown-menu-right rounded-0" *ngIf="aboutUsDropdown" aria-labelledby="navbarDropdown">
            <a class="dropdown-item nav-link" [routerLink]="['/about-us']">Company Profile</a>
            <a class="dropdown-item nav-link" [routerLink]="['/about-us/team']">The T-Musicman Team</a>
          </div>
        </li> -->
        <!-- <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/about-us']">About Us</a>
        </li> -->
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/team']">Team</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/managed-events']">Managed Events</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/managed-artists']">Managed Artists</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/contact-us']">Contact Us</a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<app-navigation-modal [(visible)]="showMenu">
</app-navigation-modal>

<!-- <app-live-streaming></app-live-streaming> -->